<template>
  <div class="dashboard-navbar">
    <div class="dashboard-navbar__brand">
      <!-- LOGO -->
      <img
        v-if="
          company &&
          company.logo_url !== '' &&
          company.logo_url !== undefined &&
          company.logo_url !== null && 
          !isAnonimous
        "
        class="logo_img mx-4"
        :src="company.logo_url"
        alt="company logo"
      />
      <img
        v-else-if="!isAnonimous"
        class="w-16 mx-4"
        src="@/assets/images/logo/logo.png"
        alt="default logo"
      />
    </div>
    <!-- <div class="dashboard-navbar__company mobile-hidden">
      <h1 v-if="this.company && this.company.name !== ''">
        {{ this.company.name }}
      </h1>
    </div> -->
    <vs-spacer></vs-spacer>
    <div class="the-navbar__user-meta flex items-center mobile-hidden">
      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <div class="con-img mx-4">
          <img
            v-if="
              basicInfo.photo_url !== undefined &&
              basicInfo.photo_url !== '' &&
              basicInfo.photo_url !== null
            "
            :src="basicInfo.photo_url"
            alt="user-img"
            key="online-img"
            width="40"
            height="40"
            class="rounded-full shadow-md cursor-pointer block object-cover"
          />
          <img
            v-else
            src="@/assets/images/portrait/small/avatars1.png"
            alt="user-img"
            key="local-img"
            width="40"
            height="40"
            class="rounded-full shadow-md cursor-pointer block"
          />
        </div>
        <vs-dropdown-menu class="vx-navbar-dropdown whitespace-no-wrap">
          <ul style="min-width: 9rem">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="goToSettings()"
            >
              <span class="ml-2">Configurações</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="goToProfileVisibility()"
            >
              <span class="ml-2">Visibilidade do Perfil</span>
            </li>
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="doLogout()"
            >
              <span class="ml-2">Sair</span>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("auth", ["isUserLoggedIn"]),
    ...mapState("company", ["company"]),
    name: {
      get() {
        return this.basicInfo.name || "";
      },
    },
    isAnonimous() {
      const { company_label } = this.$router.history.current.params;
      return company_label === "anonima";
    },
  },
  methods: {
    ...mapActions("basicInfo", ["clearBasicInfoState"]),
    ...mapActions("address", ["clearAddressState"]),
    ...mapActions("experience", ["clearExperienceState"]),
    ...mapActions("language", ["clearLanguageState"]),
    ...mapActions("formation", ["clearFormationState"]),
    ...mapActions("skill", ["clearSkillState"]),
    ...mapActions("step", ["clearStepsState"]),
    ...mapActions("vacancy", ["clearVacancyState"]),

    doLogout() {
      if (this.isUserLoggedIn) {
        localStorage.clear();
        sessionStorage.clear();
        this.clearBasicInfoState();
        this.clearAddressState();
        this.clearExperienceState();
        this.clearLanguageState();
        this.clearFormationState();
        this.clearSkillState();
        this.clearStepsState();
        this.clearVacancyState();

        this.$store.dispatch("updateTab", 1);

        const params = this.$router.history.current.params;
        this.$router.push({ name: "signin", params: { ...params } });
      }
    },

    goToSettings() {
      const { params } = this.$router.history.current;
      this.$router.push({
        name: "dashboard-settings",
        params,
        query: {
          tab: 0,
        }
      });
    },

    goToProfileVisibility() {
      const { params } = this.$router.history.current;
      this.$router.push({
        name: "dashboard-settings",
        params,
        query: {
          tab: 1,
        }
      });
    },
  },
};
</script>

<style lang="scss">
.dashboard-navbar {
  display: flex;
  padding: 0.5rem 0.5em;
  justify-content: center;
  background-color: white;
  max-height: 61px;
}
.dashboard-navbar__brand {
  display: flex;

  h2 {
    margin-left: 1rem;
    color: #252525;
    text-align: center;
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.52px;
  }
}
.dashboard-navbar__company {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;

  & h1 {
    margin-bottom: 0;
    font-weight: 300;
    font-size: 1.3em;
  }
}

.logo_img {
  max-width: 90px;
  max-height: 30px;
  object-fit: contain;
}
</style>
